import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { Config } from 'ngx-countdown';
import { toDate, differenceInSeconds } from 'date-fns';

import { ICountdown } from './countdown.interface';

@Component({
    selector: 'mlp-ng-countdown',
    templateUrl: './countdown.component.html',
    styleUrls: ['./countdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class CountdownSharedComponent implements OnInit {
    @Input() config: Config;
    @Input() starts: ICountdown['starts'];
    @Input() ends: ICountdown['ends'];

    ngOnInit(): void {
        const STARTS = (this.starts) ? toDate(this.starts) : toDate(Date.now());
        const ENDS = toDate(this.ends);
        const DIFFINSECS = differenceInSeconds(ENDS, STARTS);

        this.config = { leftTime: DIFFINSECS, clock: ['h', 100, 2, 'm', 60, 2, 's', 60, 2, 'u', 10, 1] };
    }
}
